import React, { Fragment } from 'react';

import Input from '@lightspeed/cirrus-input';
import FormField from 'cirrus/FormField';

const CCTerminalForm = ({ errors, handleBlur, handleChange, touched, values }) => (
  <Fragment>
    <FormField className="cr-mb-2">
      <Input
        className="cr-width-full"
        data-test="retail-payments-ccterminal-name"
        label="Terminal Name"
        maxLength="50"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        status={touched.name && errors.name ? { type: 'error', message: errors.name } : {}}
        type="text"
        value={values.name}
      />
    </FormField>
  </Fragment>
);

export default CCTerminalForm;
